import React, { Component } from "react";
import PropTypes from "prop-types";
import { Form, Select } from "semantic-ui-react";
import { TitleCase } from "../../common";
import ControlTitle from "../ControlTitle";
var decode = require("unescape");

class Dropdown extends Component {
  handleChange(e) {
    this.props.onChange(
      this.props.repeatingForm,
      this.props.element_id,
      e.target.textContent
    );
  }

  renderSelect() {
    const { element_value, validate, error, ...formControl } = this.props;

    var options = formControl.element_params.V.split("\r\n");
    var s_value = "";
    var optionsData = [];
    options.forEach(element => {
      optionsData.push({ text: TitleCase(decode(element)), value: element });
      if (element_value === decode(element)) {
        s_value = element;
      }
    });

    if (validate && error) {
      return (
        <Select
          value={s_value}
          className="error"
          placeholder="Select"
          onChange={this.handleChange.bind(this)}
          options={optionsData}
        />
      );
    }

    return (
      <Select
        value={s_value}
        placeholder="Select"
        onChange={this.handleChange.bind(this)}
        options={optionsData}
      />
    );
  }

  render() {
    const { element_prompt, element_value, ...formControl } = this.props;

    return (
      <div className="formControlItem">
        <Form.Field>
          <ControlTitle
            text={element_prompt}
            optional={formControl.element_optional === "1" ? true : false}
          ></ControlTitle>
          {this.renderSelect()}
        </Form.Field>
      </div>
    );
  }
}

Dropdown.propTypes = {
  element_prompt: PropTypes.string.isRequired,
  element_value: PropTypes.string.isRequired,
  element_id: PropTypes.number.isRequired,
  error: PropTypes.bool.isRequired,
  validate: PropTypes.bool.isRequired,
  onChange: PropTypes.func.isRequired
};

export default Dropdown;



// WEBPACK FOOTER //
// ./src/components/Dropdown/index.js